// extracted by mini-css-extract-plugin
export default {"headerActions":"ContactUserDetailPage_headerActions__sH3qi","detailMain":"ContactUserDetailPage_detailMain__SSdF2"};